<template>
  <div class="fill-height" :style="backgroundStyle">
    <v-content>
      <v-container fluid>
        <router-view/>
      </v-container>
    </v-content>

    <footer-bar
    ></footer-bar>
  </div>
</template>

<script>
import FooterBar from '@/components/FooterBar';

import ImageBackground from '@/mixins/ImageBackground';


export default {
  components: {
    FooterBar
  },

  mixins: [
    ImageBackground
  ]
};
</script>
